module.exports = __webpack_public_path__ + "static/img/iTPM-icon.35ac10b4.png";